export default __webpack_public_path__ + "static/media/407.e75c84d3.png";